import { Injectable, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { catchError, map, of, switchMap } from 'rxjs';

import { CompetitionCategory } from './competition.interface';
import { AuthenticationService } from '../authentication/authentication.service';
import { PresubscriptionResourceService } from '../presubscription-resource/presubscription-resource.service';

@Injectable({ providedIn: 'root' })
export class UserCompetitionCategoriesService {
  private readonly auth = inject(AuthenticationService);
  private readonly presubResource = inject(PresubscriptionResourceService);

  public readonly categories = toSignal(
    toObservable(this.auth.isAuthenticatedSignal).pipe(
      switchMap((isAuth) =>
        isAuth
          ? this.presubResource.listMine().pipe(
              map((presubscriptions) => {
                const cats = presubscriptions.map((p) => p.category);
                return [...new Set(cats)] as CompetitionCategory[];
              }),
              catchError(() => of([] as CompetitionCategory[])),
            )
          : of([] as CompetitionCategory[]),
      ),
    ),
    { initialValue: [] as CompetitionCategory[] },
  );

  public readonly queryParams = toSignal(
    toObservable(this.categories).pipe(
      map((cats) => ({
        categories: cats.length ? cats.join(',') : null,
      })),
    ),
    { initialValue: { categories: null as string | null } },
  );
}
